import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { GeneralSettings } from '../model/general-settings.model';
import { map, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from './httphelper.service';

const BASE_API_URL = `${environment.apiUrl}settings/generalsettings`;

@Injectable({
	providedIn: 'root',
})
export class CarehomeSettingsService {
	private settingsSubject = new BehaviorSubject<GeneralSettings | null>(null);

	constructor(private http: HttpClient,
		private httpHelperService: HttpHelperService,
	) { }

	getCarehomeSettings(): Observable<GeneralSettings> {
		if (this.settingsSubject.getValue()) {
			return this.settingsSubject.asObservable();
		}

		return this.http.get<GeneralSettings>(`${BASE_API_URL}`, this.httpHelperService.getHttpOptions())
			.pipe(
				map((response: any) => response.body as GeneralSettings),
				tap((response: any) => {
					this.settingsSubject.next(response.body as GeneralSettings);
				})
			);
	}

	updateCarehomeSettings(settings: GeneralSettings): Observable<any> {
		return this.http.put<any>(`${BASE_API_URL}`, settings, this.httpHelperService.getHttpOptions()).pipe(
			tap(() => {
				this.settingsSubject.next(settings);
			})
		);
	}

	clearLocalSettings(): void {
		this.settingsSubject.next(null);
	}
}